/**
 * Custom functionality for the Our Story page.
 */

/* global jQuery */

const $ = jQuery;   // jQuery loaded via WordPress enqueue process
const clippedParallax = require('../components/clipped-parallax');



/**
 * Init any parallax modules on the page
 */
function initClippedParallax() {

    // Set up 'Our Ingredients' background parallax
    let paraOptions = {
        container: '.our-ingredients-heading',
        bg: '.our-ingredients-heading__bg',
        svg: '.our-ingredients-heading__bg-svg',
        image: '.our-ingredients-heading__bg-image',
        clipPath: '#our-ingredients-heading__bg-clip-path',
        clipShape: '#our-ingredients-heading__bg-clip-shape',
        clipPathWidth: 1366,
        clipPathHeight: 600,
        imageWidth: 1366,
        imageHeight: 800,
        intensity: 0.5,    // 0 - minimal effect | larger values increase effect
        bottomAnchor: true    // Anchor bg at bottom of container (to be used with
        // css definition to bottom align bg block)           
    };
    clippedParallax.setupParallax(paraOptions);
}




exports.init = function () {
    initClippedParallax();
};